// extracted by mini-css-extract-plugin
module.exports = {"btn":"LockBar_btn__2hTEF","btnText":"LockBar_btnText__252K-","icon":"LockBar_icon__2BbCN","lockbar":"LockBar_lockbar__3OirU"};